module.exports = function() {
  return new Worker(__webpack_public_path__ + "5e53657b781dfd8b801a.worker.js");
};